/* eslint-disable indent */
import styled from 'styled-components';

export const Nub = styled.span`
	position: absolute;
	display: block;
	top: ${({ position }) => {
		switch(position) {
			case 'top':
				return '0';
			case 'right':
				return '50%';
			case 'bottom':
				return '100%';
			case 'left':
				return '50%';
			default:
				return '0';
		}
	}};
	left: ${({ position }) => {
		switch(position) {
			case 'top':
				return '50%';
			case 'right':
				return '100%';
			case 'bottom':
				return '50%';
			case 'left':
				return '0';
			default:
				return '50%';
		}
	}};
	transform: ${({ position }) => {
		switch(position) {
			case 'top':
				return 'translateX(-50%) translateY(-100%)';
			case 'right':
				return 'translateX(-0.25rem) translateY(-50%) rotate(90deg)';
			case 'bottom':
				return 'translateX(-50%) translateY(-100%) translateY(0.75rem) rotate(-180deg)';
			case 'left':
				return 'translateX(-1.25rem) translateY(-50%) rotate(-90deg)';
			default:
				return 'translateX(-50%) translateY(-100%)';
		}
	}};
	transition: opacity 0s;
	transition-delay: ${(props) => props.delay ? '500ms' : '0'};
	z-index: 39;
	border-width: 0.75rem 0.75rem 0;
	border-style: solid;
	border-color: ${({ theme, background }) => (background ? theme[background] : theme['blue-base'])} transparent transparent;
	opacity: 0;
	pointer-events: none;
`;

export const Content = styled.span`
	position: absolute;
	display: block;
	top: ${({ position }) => {
		switch(position) {
			case 'top':
				return '0';
			case 'right':
				return '50%';
			case 'bottom':
				return '100%';
			case 'left':
				return '50%';
			default:
				return '0';
		}
	}};
	left: ${({ position }) => {
		switch(position) {
			case 'top':
				return '50%';
			case 'right':
				return '100%';
			case 'bottom':
				return '50%';
			case 'left':
				return '0';
			default:
				return '50%';
		}
	}};
	transform: ${({ position }) => {
		switch(position) {
			case 'top':
				return 'translateX(-50%) translateY(-100%) translateY(-0.325rem)';
			case 'right':
				return 'translateX(0%) translateY(-50%) translateX(0.5rem)';
			case 'bottom':
				return 'translateX(-50%) translateY(0%) translateY(0.325rem)';
			case 'left':
				return 'translateX(-100%) translateY(-50%) translateX(-0.5rem)';
			default:
				return 'translateX(-50%) translateY(-100%) translateY(-0.325rem)';
		}
	}};
	transition: opacity 0s;
	transition-delay: ${(props) => props.delay ? '500ms' : '0'};
	z-index: 40;
	border-radius: 0.25rem;
	background: ${({ theme, background }) => (background ? theme[background] : theme['blue-base'])};
	padding: 0.25rem 0.5rem;
	min-width: ${({ size }) => {
		if( Number(size) > 0 ) {
			return '0';
		}

		switch(size) {
			case 'sm':
				return '4rem';
			case 'lg':
				return '9rem';
			case 'xl':
				return '12rem';
			default:
				return '6rem';
		}
	}};
	width: ${({ size }) => Number(size) > 0 ? `${size}rem` : 'auto'};
	opacity: 0;
	text-align: center;
	line-height: 1.4;
	color: ${({ theme }) => theme['white']};
	font-size: ${({ fontSize }) => {
		if( Number(fontSize) > 0 ) {
			return fontSize+'rem';
		}

		switch(fontSize) {
			case 'sm':
				return '0.6rem';
			case 'lg':
				return '1rem';
			case 'xl':
				return '1.2rem';
			default:
				return '0.8rem';
		}
	}};
	font-weight: 700;
	pointer-events: none;
`;

export const Container = styled.span`
	position: relative;
	display: inline-block;

	&:hover {
		${Nub},
		${Content} {
			opacity: 1;
		}
	}
`;
